<template>

    <v-container>
        <v-layout text-center wrap>


            <!-- <v-flex mb-4> -->
                <div class="atc">
                    <!-- <h1 class="display-2 font-weight-bold mb-3">Authenticating</h1> -->
                    <h1 class="authenticating-title">Authenticating</h1>
                    <v-progress-linear indeterminate color="#c42111" striped height="8"></v-progress-linear>
                </div>
            <!-- </v-flex> -->

        </v-layout>
  </v-container>

  
</template>

<script>
export default {
    name: 'Authenticating',
    props: [],
    components: {

    },
    data: () => ({

    }),

    computed: {

    },

    methods: {

    },

    mounted() {

    }
};
</script>

<style scoped>


    .atc {
        margin: auto;
        margin-top: -50px;
    }
    .atc h1 {
        text-transform: uppercase;
        letter-spacing: 5px !important;
    }

    .authenticating-title {
        font-size: 3rem !important;
        line-height: 3.125rem;
        font-weight: 700 !important;
        margin-bottom: 12px !important;
        letter-spacing: normal !important;
        font-family: "Roboto", sans-serif !important;
    }

    @media screen and (max-width: 600px) {
        .authenticating-title {
            font-size: 2.125rem !important;
            line-height: 2.5rem;
            letter-spacing: 0.0073529412em !important;
            font-weight: 700 !important;
            margin-bottom: 12px !important;
            font-family: "Roboto", sans-serif !important;

            letter-spacing: 3px !important;
        }
    }

</style>
